import { useState } from "react";

import { crearPlanilla } from "../services/espacio";
import { libroDePlantilla, PLANTILLAS } from "../shared/plantillasPlanilla";

import "./css/plantillas.css";

/* «Nueva desde plantilla»: el selector de la lista de Mi espacio.
 *
 * Elegir una tarjeta crea una planilla NUEVA del usuario, ya armada (ver
 * `shared/plantillasPlanilla`), y avisa con `onCreada(id)` para que la lista
 * la abra. Vive aparte de MiEspacio.jsx para que la pantalla grande no cargue
 * con el catálogo ni con su CSS.
 *
 * Las tarjetas son botones de verdad (se llega con Tab y se eligen con Enter)
 * y en el celular quedan una abajo de la otra, a todo el ancho y con lugar
 * para el dedo. Mientras se crea una se apagan todas: dos toques rápidos no
 * tienen que dejar dos planillas iguales. */
export default function PlantillasPlanilla({ onCreada, onCerrar }) {
  const [creando, setCreando] = useState(null);
  const [error, setError] = useState(null);

  async function elegir(p) {
    if (creando) return;
    setCreando(p.id);
    setError(null);
    try {
      const id = await crearPlanilla(p.nombre, libroDePlantilla(p));
      // Después de esto la lista abre el editor y este panel se desmonta:
      // no se toca más el estado.
      onCreada(id);
    } catch (e) {
      setError((e && e.message) || "No se pudo crear la planilla.");
      setCreando(null);
    }
  }

  return (
    <section className="plt-panel" aria-label="Plantillas">
      <div className="plt-cabeza">
        <h3>Nueva desde plantilla</h3>
        <button type="button" className="esp-btn" onClick={onCerrar}>Cerrar</button>
      </div>
      <p className="plt-sub">
        Elegí una y se crea una planilla tuya ya armada, con las fórmulas y un
        ejemplo. Lo amarillo es lo que cambiás vos; lo demás se calcula solo.
      </p>
      {error && <p className="plt-error" role="alert">{error}</p>}
      <div className="plt-grilla">
        {PLANTILLAS.map((p) => (
          <button
            key={p.id} type="button" className="plt-tarjeta"
            disabled={!!creando} aria-busy={creando === p.id} onClick={() => elegir(p)}
          >
            <span className="plt-icono" aria-hidden="true">{p.icono}</span>
            <span className="plt-texto">
              <b>{p.nombre}</b>
              <span className="plt-desc">{p.descripcion}</span>
              {creando === p.id
                ? <span className="plt-nota">Creando…</span>
                : p.usaHub.length > 0 && <span className="plt-nota">Trae del hub: {p.usaHub.join(", ")}</span>}
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
